// extracted by mini-css-extract-plugin
export default {"riskUniverse":"RiskUniverse_riskUniverse__Rltoz","box":"RiskUniverse_box__VR4Bx","badge":"RiskUniverse_badge__bQ34b"};